// ======================================================================
// File Name       : EmailEditUserSearchList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Button, Col, Row, Table } from 'react-bootstrap';
import Pagination from '../../components/Pagination';
import { DORMANT_STATE } from '../../constants/index';
import { validEmail } from '../../utils/ValidateUtils';

class EmailEditUserSearchList extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
    nextProps.searchUserResult === this.props.searchUserResult &&
    nextProps.checkedUser === this.props.checkedUser &&
    nextProps.editingUser === this.props.editingUser &&
    nextProps.authority === this.props.authority;
    return !shouldNotUpdate;
  }

  render() {
    const {
      searchUserResult,
      checkedUser,
      editingUser,
    } = this.props;

    return (
      <div>
        <Row>
          <Col sm={12} className="margin-top-10">
            <Col sm={7} className="padding-left-right-clear label-middle">
              <Button variant='default' onClick={this.props.handleAddRemoveAllUser}>検索結果のユーザーを全て選択/解除</Button>
              <span className="required padding-left-5">※メールアドレスが設定されていないユーザーは選択されません</span>
            </Col>
          </Col>
        </Row>
        <Table striped hover className="margin-top-7 margin-bottom-10">
          <thead>
            <tr>
              <th width="60" />
              <th>ユーザー名</th>
              <th>ログインID</th>
              <th>グループ名</th>
              <th>メールアドレス</th>
            </tr>
          </thead>
          <tbody>
            {
              searchUserResult && searchUserResult.allSecernIds &&
              searchUserResult.allSecernIds.map((userSecernId, index) => {
                const user = searchUserResult.bySecernId[userSecernId];
                const checked = checkedUser.allSecernIds.indexOf(userSecernId) > -1 || !!editingUser[userSecernId];
                return (
                  <tr key={index} className={user.dormantState === DORMANT_STATE.INACTIVE ? 'inactive-class' : ''}>
                    <td>
                      <Form.Check
                        type='checkbox'
                        className="text-center padding-left-5 margin-clear"
                        value={userSecernId}
                        checked={checked && user.mailAddress && validEmail(user.mailAddress)}
                        onChange={this.props.handleUserCheck}
                        disabled={!!editingUser[userSecernId] || !user.mailAddress || !validEmail(user.mailAddress)} />
                    </td>
                    <td>
                      {user.userName}
                    </td>
                    <td>
                      {user.loginId}
                    </td>
                    <td>
                      {user.groupName}
                    </td>
                    <td>
                      {user.mailAddress}
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </Table>
        <Col sm={12} className="padding-left-right-clear">
          <Pagination
            className="justify-content-center margin-clear"
            startPosition={searchUserResult.startPosition}
            recordNum={searchUserResult.recordNum}
            handlePageSelect={this.props.handlePageChange}
          />
        </Col>
        <Row>
          <Col sm={12} className="text-center margin-top-10">
            <Button
              variant="primary"
              className="btn-96"
              onClick={this.props.handleAddSelectedUser}
              disabled={(!checkedUser || !checkedUser.allSecernIds || !checkedUser.allSecernIds.length)}
            >
              追加
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

export default EmailEditUserSearchList;
